(function (algolia, instantsearch) {
  if (!algolia.full_results) {
    return;
  }

  var _ = algolia._,
      $ = algolia.jQuery;


  $('head').append('<style>' + algolia.config.results_selector + ' { visibility: hidden }</style>');

  console.log('Algolia: Instant-Search');

  algolia.templates.full_results = {
    page: algolia.compileTemplate('full_results'),
    product: algolia.compileTemplate('full_results_product')
  };

  $(document).ready(function () {
    algolia.$results = $(algolia.config.results_selector);

    algolia.$results.html(algolia.templates.full_results.page.render({ facets: algolia.config.facets }));

    // Init
    algolia.instant_search = instantsearch({
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      indexName: '' + algolia.config.index_prefix + 'products',
      urlSync: {}
    });

    // Bind helpers
    _.forEach(algolia.helpers, function (helper, name) {
      algolia.instant_search.templatesConfig.helpers[name] = helper;
    });
    algolia.instant_search.templatesConfig.compileOptions = algolia.hoganOptions;

    // Search input
    algolia.instant_search.addWidget(
      instantsearch.widgets.searchBox({
        container: '.algolia-full-results .algolia-search-box',
        placeholder: 'Search for products',
        poweredBy: true
      })
    );

    // Stats
    algolia.instant_search.addWidget(
      instantsearch.widgets.stats({
        container: '.algolia-full-results .algolia-stats'
      })
    );

    // Sort orders
    var sort_order_base = '' + algolia.config.index_prefix + 'products';
    var sort_orders = [ { name: sort_order_base, label: 'Relevance' } ];
    _.forEach(algolia.config.sort_orders, function (sort_order) {
      if (!_.isUndefined(sort_order.asc) && !_.isNull(sort_order.asc) && (sort_order.asc.active === true || sort_order.asc.active === '1')) {
        sort_orders.push({ name: sort_order_base + '_' + sort_order.key + '_asc', label: sort_order.asc.title });
      }
      if (!_.isUndefined(sort_order.desc) && !_.isNull(sort_order.desc) && (sort_order.desc.active === true || sort_order.desc.active === '1')) {
        sort_orders.push({ name: sort_order_base + '_' + sort_order.key + '_desc', label: sort_order.desc.title });
      }
    });

    algolia.instant_search.addWidget(
      instantsearch.widgets.indexSelector({
        container: '.algolia-full-results .algolia-sort-orders',
        indices: sort_orders,
        cssClass: '' // Temp fix
      })
    );

    // Facets
    _.forEach(algolia.config.facetsWidgets, function (widget) {
      algolia.instant_search.addWidget(instantsearch.widgets[widget.name](widget.params));
    });

    // Hits
    algolia.instant_search.addWidget(
      instantsearch.widgets.hits({
        container: '.algolia-full-results .algolia-hits',
        templates: {
          empty: algolia.getTemplate('full_results_no_result'),
          item: algolia.getTemplate('full_results_product')
        },
        hitsPerPage: algolia.config.products_full_results_hits_per_page
      })
    );
    
    // Pagination top
    algolia.instant_search.addWidget(
      instantsearch.widgets.pagination({
        container: '.algolia-full-results .algolia-pagination-top',
        padding: 3,
        maxPages: 20
      })
    );

    // Pagination bottom
    algolia.instant_search.addWidget(
      instantsearch.widgets.pagination({
        container: '.algolia-full-results .algolia-pagination-bottom',
        padding: 3,
        maxPages: 20
      })
    );

    // Main
    algolia.instant_search.start();
    algolia.loadEvents();
    algolia.$results.css('visibility', 'visible');
    
    var _viewport = function() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        //return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
      return  e[ a+'Width' ];
    };
    
    var cleanUpFacets = function() {
      $('.algolia-facet-count').each(function () {
        if ($(this).text().trim() === '0') {
          $(this).parent().parent().parent().hide();
        }
      });
    };
    
    algolia.instant_search.once('render', function() {
      if( _viewport() < 768 ){
        $('.algolia-facets').insertBefore('.algolia-results');
      }
      cleanUpFacets();
      if (typeof(yotpo) !== 'undefined') {
        yotpo.initWidgets();
      }

      algolia.instant_search.on('render', function() {
        cleanUpFacets();
      });
    });
  });
}(algoliaShopify, instantsearch));
